import { render, staticRenderFns } from "./ContactBrossure.vue?vue&type=template&id=799ef2f3&"
import script from "./ContactBrossure.vue?vue&type=script&lang=js&"
export * from "./ContactBrossure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports